module.exports = __webpack_public_path__ + "img/BRCA1_Endothelial.7bf0ff2e.png";